import { useDispatch, useSelector } from "react-redux";
import { DeleteIndirectBeneficiaries } from "../../../Redux/Reducers/ReportStage/IndirectBeneficiaries";
import IndirectBeneficiariesForm from "./IndirectBeneficiariesForm";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import loadConfig from "../../../Services/Api/ApiServices";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";

const IndirectBeneficiaries = (props) => {
  const AddIndirectBeneficiaries = useSelector(
    (state) => state.IndirectBeneficiaries.AddIndirectBeneficiaries
  );
  const UpdateIndirectBeneficiaries = useSelector(
    (state) => state.IndirectBeneficiaries.UpdateIndirectBeneficiaries
  );
  const [jsonData, setJsonData] = useState({});

  const [indirectBeneficiariesId, setindirectBeneficiariesId] = useState(null);

  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "indirectBeneficiariesName",
      ShowStatus: true,
      NmaeColumn: "الاسم",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "roleInProject",
      ShowStatus: true,
      NmaeColumn: "الدور في البحث",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);

        setindirectBeneficiariesId(objects.indirectBeneficiariesId);
        setPopUpBodyStatus(true);

        console.log(objects, "objects");
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "تعديل",
      ShowStatus: props.iconsEditOrView,
      InitialScreeningAssessment: true,
    },
    {
      Click: async (e) => {
        // var objects = JSON.parse(e.target.value);
        // var indirectBeneficiariesId = objects.indirectBeneficiariesId;

        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteIndirectBeneficiaries({
                indirectBeneficiariesId: e.target.value,
              })
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: props.iconsEditOrView,

      // ShowStatus: true,
      //   !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: (
      <IndirectBeneficiariesForm reportStageId={props.reportStageId} />
    ),

    title: "مستفيدين غير مباشرين",
    maxWidth: "500px",
    maxHeight: "500px",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: (
      <IndirectBeneficiariesForm
        Action="edit"
        indirectBeneficiariesId={indirectBeneficiariesId}
        reportStageId={props.reportStageId}
      />
    ),

    title: "مستفيدين غير مباشرين",
    maxWidth: "500px",
    maxHeight: "500px",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [
    AddIndirectBeneficiaries,
    indirectBeneficiariesId,
    UpdateIndirectBeneficiaries,
  ]);
  console.log(props.iconsEditOrView,"ssssssdwdwwwwwwwwdwd");
  
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        // RequestsManagerValue={true}
        AllValueAction={true}
        uniqueValue={"indirectBeneficiariesId"}
        valueButtonAction={"indirectBeneficiariesId"}
        URL={`api/IndirectBeneficiaries/GetListIndirectBeneficiaries`}
        UrlBody={{
          reportStageId: props.reportStageId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={props.iconsAdd}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"taskId"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        uniqeKeyNameRedux={"tasksList"}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};

export default IndirectBeneficiaries;
